document.addEventListener('DOMContentLoaded', function () {
  const featuredCollections = document.querySelectorAll(
    '.featured-collection.splide',
  );

  featuredCollections.forEach(function (featuredCollection, index) {
    const leftArrow = featuredCollection.querySelector('.left-arrow');
    const rightArrow = featuredCollection.querySelector('.right-arrow');

    const splideFeatured = new Splide(featuredCollection, {
      type: 'loop',
      drag: true,
      arrows: false,
      snap: true,
      breakpoints: {
        768: {
          type: 'slide',
          perPage: 1,
        },
      },
      perPage: 4,
      perMove: 1,
      pagination: false,
      autoplay: true,
      interval: 5000,
      speed: 1000,
    });

    splideFeatured.mount();

    leftArrow.addEventListener('click', function () {
      splideFeatured.go('<');
    });

    rightArrow.addEventListener('click', function () {
      splideFeatured.go('>');
    });
  });
});
